import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useActionDefaultDebug } from "hook/base/debug/useActionDefaultDebug";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DebugAdd = () => {
  // -------------------------- VAR -----------------------------
  const { handleOpen } = useActionDefaultDebug();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Button onClick={handleOpen} type="primary" icon={<PlusOutlined />}>
      Thêm Job Debug
    </Button>
  );
};
export default DebugAdd;
